/**
 * guestPass — lets a visitor continue browsing without an account when the
 * storefront hard gate is active ("Browse as guest" / "Sign up later").
 *
 * Choosing it stores a local pass which downgrades the HARD gate to the
 * SOFT gate for that browser: browsing is allowed, but any buy/checkout
 * action still routes through /auth-gate (soft gate rules).
 *
 * The pass is cleared automatically once the visitor signs in.
 */
const GUEST_PASS_KEY = "khays_guest_pass_v1";

/** True when the visitor has opted to browse as a guest. */
export function hasGuestPass(): boolean {
  try {
    return localStorage.getItem(GUEST_PASS_KEY) === "1";
  } catch {
    return false;
  }
}

export function grantGuestPass(): void {
  try { localStorage.setItem(GUEST_PASS_KEY, "1"); } catch {}
  try { window.dispatchEvent(new CustomEvent("khays:guest-pass-changed")); } catch {}
}

export function clearGuestPass(): void {
  try { localStorage.removeItem(GUEST_PASS_KEY); } catch {}
  try { window.dispatchEvent(new CustomEvent("khays:guest-pass-changed")); } catch {}
}
